import { ILoginRequest } from '../../models/ILoginRequest';
import HttpClient from '../../helpers/axios';

class AuthService {
  Login(user: ILoginRequest) {
    return HttpClient.post('/api/v1/login', user);
  }
}

export default new AuthService();